export const config = {
  baseUrl: import.meta.env.VITE_PB_URL || "http://localhost:8091",
  apiUrl: `${import.meta.env.VITE_PB_URL}/api/`,
  imageApi: import.meta.env.VITE_IMAGE_API,
  appEnv: import.meta.env.APP_ENV || "DEV",
  publicPosthogKey: import.meta.env.VITE_PUBLIC_POSTHOG_KEY,
} as const;
